export const BACKEND_API_CHANNEL_PARTNER = {
  GENERATE_CHANNEL_PARTNER_OTP: 'authentication/channel-partner/generate-otp',
  VALIDATE_CHANNEL_PARTNER_OTP: 'authentication/channel-partner/verify-otp',
}
